import React, { useState } from "react";
import { Form, Select } from "semantic-ui-react";
import { ZENDESK_INSTANCE_OPTIONS } from "../../../../../../../../../constants/endpoints";

const REASSIGN_INSTANCE_OPTIONS = ZENDESK_INSTANCE_OPTIONS.filter(
  (option) => option.value === "entryllc",
);

const DEFAULT_INSTANCE = REASSIGN_INSTANCE_OPTIONS[0]?.value || "entryllc";

const ReassignZendeskTicketForm = ({ applicant }) => {
  const [zendeskInstance, setZendeskInstance] = useState(
    REASSIGN_INSTANCE_OPTIONS.some(
      (option) => option.value === applicant?.zendeskInstance,
    )
      ? applicant.zendeskInstance
      : DEFAULT_INSTANCE,
  );
  const [zendeskId, setZendeskId] = useState(applicant?.zendeskId || "");

  return (
    <div>
      <Form.Field required>
        <label>Zendesk instance</label>
        <Select
          options={REASSIGN_INSTANCE_OPTIONS}
          value={zendeskInstance}
          onChange={(_, { value }) => setZendeskInstance(value)}
          fluid
        />
        <input type="hidden" name="zendeskInstance" value={zendeskInstance} />
      </Form.Field>

      <Form.Field required>
        <Form.Input
          label="Zendesk ID"
          name="zendeskId"
          placeholder="Enter the Zendesk ticket ID"
          value={zendeskId}
          onChange={(_, { value }) => setZendeskId(value.trim())}
          required
        />
      </Form.Field>
    </div>
  );
};

export default ReassignZendeskTicketForm;
